import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function UploadToggle({ value, onChange }) {
  const handleChange = (event, newValue) => {
    // Prevent null selection by keeping current value if newValue is null
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="Upload Type"
      sx={{ mb: 2 }}
      style={{ display: "block", margin: "2rem" }}
    >
      <ToggleButton value="player-averages">Player Averages</ToggleButton>
      <ToggleButton value="team-stats">Team Stats</ToggleButton>
      <ToggleButton value="player-game-stats">Game Stats</ToggleButton>
    </ToggleButtonGroup>
  );
}
